import MonitoringDashboard from 'containers/user/critical-elements-monitoring/monitoring-dashboard';

interface MonitoringTabProps {
  clientId: string;
}

const MonitoringTab = ({ clientId }: MonitoringTabProps): React.JSX.Element => (
  <div className="mt-5">
    <MonitoringDashboard
      key={clientId}
      clientId={clientId}
      isAnalyticsEnabled={false}
    />
  </div>
);

export default MonitoringTab;
